import AttachmentsPanel from "components/attachments/AttachmentsPanel";
import { isExternalOrReadonlyAdmin } from "form/util";
import FormItemTitle from "pages/vehicle/FormItemTitle";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setFleetWithPremiums } from "store/fleetForm";
import { useSelector } from "store/hooks";
import { Attachment } from "types/types";

// Fleet level documents (vehicleId == null); only internal users may change them
export const Attachments = ({ attachmentsRef }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const fleet = useSelector((s) => s.fleetForm.fleetWithPremiums);
  const userRole = useSelector((s) => s.auth.userRole);

  if (!fleet?.fleetId) return null;

  const onAttachmentsChange = (next: Attachment[]) => {
    dispatch(setFleetWithPremiums({ ...fleet, attachments: next }));
  };

  return (
    <div
      ref={attachmentsRef}
      id="attachments-tab"
      style={{
        marginTop: "100px",
      }}
    >
      <FormItemTitle
        title={t("bfm.vehicle.tabs.attachments")}
        iconName={"Attach"}
        iconMargin={0}
      />
      <AttachmentsPanel
        fleetId={fleet.fleetId}
        vehicleId={null}
        attachments={fleet.attachments}
        onAttachmentsChange={onAttachmentsChange}
        canEdit={!isExternalOrReadonlyAdmin(userRole)}
      />
    </div>
  );
};
